export const THAI_LANG_CODE = 'th'
export const DEFAULT_IBEACON_LOCALE = 'en'
